import { subscriptionHeaderConfigAxios } from '@/utils/api-instance';

export const subscriptionHeader = async () => {
    const api = subscriptionHeaderConfigAxios();
    const { data } = await api.get('');
    return data;
};
